import React from "react";

const HealthcareIndustryLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section className="bg-[#2f2a35] text-white">
                <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-10 items-center">
                    <div>
                        <span className="text-sm uppercase text-gray-300">Industries</span>
                        <h1 className="text-4xl md:text-5xl font-bold mt-4">
                            Healthcare
                        </h1>
                        <p className="mt-6 text-gray-200 max-w-xl">
                            Empowering healthcare organizations to deliver better patient
                            outcomes through digital innovation, intelligent platforms, and
                            AI-driven transformation.
                        </p>

                        <div className="mt-6 text-sm text-orange-400">
                            Re(AI)magining™ healthcare delivery with an AI-first approach →
                        </div>
                    </div>

                    <div>
                        <img
                            src="/images/industries/helthcare/hero.jpg"
                            alt="Healthcare"
                            className="rounded-xl shadow-lg"
                        />
                    </div>
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="py-20">
                <div className="max-w-5xl mx-auto px-6 text-gray-700 space-y-4">
                    <p>
                        Healthcare systems today face increasing pressure to improve care
                        quality, optimize costs, and enhance patient engagement while
                        navigating regulatory complexity.
                    </p>
                    <p>
                        We partner with providers, payers, and life sciences organizations to
                        modernize platforms, enable data-driven decisions, and accelerate
                        digital healthcare transformation.
                    </p>
                </div>
            </section>

            {/* ================= HEALTHCARE PROVIDER ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Healthcare Provider
                        </h2>
                        <p className="text-gray-700">
                            Accelerate innovation across clinical, operational, and patient
                            engagement workflows using cloud platforms, AI, analytics, and
                            interoperable digital ecosystems.
                        </p>

                        <button className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our healthcare expertise
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>• Digital Health Platforms</li>
                            <li>• Healthcare Data & Analytics</li>
                            <li>• Cloud & Infrastructure</li>
                            <li>• Intelligent Automation</li>
                            <li>• Salesforce for Healthcare</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                img: "https://images.unsplash.com/photo-1579684385127-1ef15d508118",
                                tag: "Healthcare Transformation",
                                title:
                                    "Healthcare organization modernizes care delivery with real-time digital platforms",
                            },
                            {
                                img: "/images/industries/helthcare/cs2.png",
                                tag: "FinTech Innovation",
                                title:
                                    "FinTech startup accelerates secure digital payments using cloud-native architecture",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
                                tag: "Enterprise Automation",
                                title:
                                    "Global enterprise streamlines operations with AI-driven workflow automation",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-white rounded-xl shadow hover:shadow-lg transition overflow-hidden"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                />

                                <div className="p-5">
                                    <span className="text-xs text-orange-600">{item.tag}</span>

                                    <p className="mt-2 font-medium">{item.title}</p>

                                    <button className="mt-3 text-orange-600 text-sm hover:underline">
                                        Read the story →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= HEALTHCARE & LIFE SCIENCES ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.85), rgba(2,6,23,.85)), url(https://images.unsplash.com/photo-1576091160550-2173dba999ef)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Healthcare & Life Sciences
                    </h2>
                    <p className="mt-4 max-w-xl text-gray-200">
                        Driving innovation across patient care, research, and life sciences
                        value chains using AI-powered digital solutions.
                    </p>
                </div>
            </section>

            {/* ================= WHY PERSISTENT ================= */}
            <section className="bg-[#fde7d9] py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    {[
                        [
                            "Deep Healthcare Expertise",
                            "Strong domain understanding across providers, payers, and life sciences.",
                        ],
                        [
                            "Technology Insights",
                            "Modern cloud, data, and AI platforms tailored for healthcare needs.",
                        ],
                        [
                            "Robust Partner Ecosystem",
                            "Strategic partnerships with hyperscalers and healthcare ISVs.",
                        ],
                    ].map(([title, desc]) => (
                        <div key={title}>
                            <h4 className="font-semibold mb-2">{title}</h4>
                            <p className="text-sm text-gray-700">{desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= NEWS ================= */}
            {/* <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="bg-white text-black rounded-xl overflow-hidden">
                                <img
                                    src="https://images.unsplash.com/photo-1584515933487-779824d29309"
                                    alt="Healthcare Insight"
                                />
                                <div className="p-5">
                                    <span className="text-xs text-orange-600">Blog</span>
                                    <p className="mt-2 font-medium">
                                        Driving efficiency and innovation in digital healthcare
                                    </p>
                                    <button className="mt-3 text-orange-600 text-sm">
                                        Read the blog →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* ================= SALESFORCE ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.9), rgba(2,6,23,.9)), url(https://images.unsplash.com/photo-1551076805-e1869033e561)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Salesforce for Healthcare and Life Sciences
                    </h2>
                    <p className="mt-4 max-w-xl text-gray-200">
                        Deliver connected, patient-centric experiences using Salesforce
                        solutions built for healthcare organizations.
                    </p>
                    <button className="mt-6 bg-white text-black px-6 py-3 rounded-md">
                        Learn more
                    </button>
                </div>
            </section>

            {/* ================= CONTACT ================= */}
            {/* <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact us</h2>

                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            rows="4"
                            placeholder="How can we help?"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default HealthcareIndustryLayout;
